// About.js
import React, { useState, useEffect } from 'react';
import './About.css';

const About = ({ language = 'en' }) => {
  const [scrollY, setScrollY] = useState(0);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  // Translations
  const translations = {
    en: {
      heroTitle: 'About The Company',
      heroSubtitle: 'Learn more about who we are and what we do!',
      companyName: 'PA GLOBAL COLLAB',
      mainDescription1: 'PA Global Collab is a leading quarry owner specializing in premium quality natural stone blocks. With a strong commitment to providing exceptional customer service and the finest stone products available, we have earned a reputation as one of the most trusted and reliable stone suppliers in the industry.',
      mainDescription2: 'At PA Global Collab, we understand that the beauty and durability of natural stone is unmatched. That\'s why we take pride in extracting and supplying a wide range of unique and high-quality stone blocks directly from our own quarries. We operate some of the finest quarries in the world, ensuring that every block we supply meets the highest standards of quality and consistency.',
      mainDescription3: 'Our experienced team of quarry experts and stone specialists are dedicated to delivering the best possible customer experience. We take great care to understand your stone requirements and provide reliable supply solutions that will exceed your expectations. From extraction to delivery, we maintain complete control over the quality process.',
      ourValues: 'Our Values',
      ourMission: 'Our Mission',
      ourVision: 'Our Vision',
      quality: 'Premium Quality',
      qualityDesc: 'We own and operate the finest quarries worldwide, ensuring exceptional standards in every stone block.',
      expertise: 'Expert Knowledge',
      expertiseDesc: 'Our skilled quarry experts bring decades of experience in stone extraction and quality assessment.',
      service: 'Reliable Supply',
      serviceDesc: 'Consistent and dependable stone block supply directly from our quarries to your projects.',
      innovation: 'Innovation',
      innovationDesc: 'Continuously improving extraction techniques and quality control processes.',
      yearsExperience: 'Years of Experience',
      happyClients: 'Happy Clients',
      projectsCompleted: 'Stone Blocks Supplied',
      countriesServed: 'Countries Served',
      missionText: 'To provide the finest natural stone blocks while delivering exceptional service and creating lasting relationships with our clients worldwide through direct quarry operations.',
      visionText: 'To be the global leader in premium stone block supply, setting the standard for quality, reliability, and customer satisfaction in the natural stone industry.',
      whyChooseUs: 'Why Choose Us',
      globalReach: 'Global Reach',
      globalReachDesc: 'Serving clients across continents with reliable quarry operations and supply chains',
      sustainability: 'Sustainable Quarrying',
      sustainabilityDesc: 'Committed to responsible quarrying practices and environmental stewardship',
      directSupply: 'Direct from Quarry',
      directSupplyDesc: 'Eliminating middlemen by supplying stone blocks directly from our own quarries',
      qualityAssurance: 'Quality Assurance',
      qualityAssuranceDesc: 'Rigorous testing and certification for all stone blocks from our quarries'
    },
    zh: {
      heroTitle: '关于公司',
      heroSubtitle: '了解更多关于我们是谁以及我们做什么！',
      companyName: 'PA GLOBAL COLLAB',
      mainDescription1: 'PA Global Collab 是专业从事优质天然石材块的领先采石场所有者。凭借提供卓越客户服务和最优质石材产品的坚定承诺，我们赢得了作为业内最值得信赖和可靠的石材供应商之一的声誉。',
      mainDescription2: '在 PA Global Collab，我们了解天然石材的美丽和耐用性是无与伦比的。这就是为什么我们自豪地直接从我们自己的采石场开采和供应各种独特和高质量的石材块。我们经营着世界上一些最好的采石场，确保我们供应的每块石材都符合最高的质量和一致性标准。',
      mainDescription3: '我们经验丰富的采石场专家和石材专家团队致力于提供最佳的客户体验。我们非常注意了解您的石材需求，并提供可靠的供应解决方案，超越您的期望。从开采到交付，我们对质量过程保持完全控制。',
      ourValues: '我们的价值观',
      ourMission: '我们的使命',
      ourVision: '我们的愿景',
      quality: '优质品质',
      qualityDesc: '我们拥有和经营全球最好的采石场，确保每块石材都具有卓越的标准。',
      expertise: '专业知识',
      expertiseDesc: '我们熟练的采石场专家在石材开采和质量评估方面拥有数十年的经验。',
      service: '可靠供应',
      serviceDesc: '直接从我们的采石场到您项目的一致可靠的石材块供应。',
      innovation: '创新',
      innovationDesc: '不断改进开采技术和质量控制流程。',
      yearsExperience: '年经验',
      happyClients: '满意客户',
      projectsCompleted: '石材块供应',
      countriesServed: '服务国家',
      missionText: '通过直接采石场运营，提供最优质的天然石材块，同时提供卓越的服务，与全球客户建立持久的关系。',
      visionText: '成为优质石材块供应的全球领导者，为天然石材行业的质量、可靠性和客户满意度设定标准。',
      whyChooseUs: '为什么选择我们',
      globalReach: '全球覆盖',
      globalReachDesc: '通过可靠的采石场运营和供应链为各大洲的客户提供服务',
      sustainability: '可持续采石',
      sustainabilityDesc: '致力于负责任的采石实践和环境管理',
      directSupply: '直接从采石场',
      directSupplyDesc: '通过直接从我们自己的采石场供应石材块来消除中间商',
      qualityAssurance: '质量保证',
      qualityAssuranceDesc: '对我们采石场的所有石材块进行严格的测试和认证'
    },
    it: {
      heroTitle: 'Chi Siamo',
      heroSubtitle: 'Scopri di più su chi siamo e cosa facciamo!',
      companyName: 'PA GLOBAL COLLAB',
      mainDescription1: 'PA Global Collab è un proprietario di cava leader specializzato in blocchi di pietra naturale di qualità premium. Con un forte impegno nel fornire un servizio clienti eccezionale e i migliori prodotti in pietra disponibili, abbiamo guadagnato una reputazione come uno dei fornitori di pietra più affidabili nel settore.',
      mainDescription2: 'In PA Global Collab, comprendiamo che la bellezza e la durabilità della pietra naturale sono ineguagliabili. Ecco perché siamo orgogliosi di estrarre e fornire una vasta gamma di blocchi di pietra unici e di alta qualità direttamente dalle nostre cave. Gestiamo alcune delle migliori cave del mondo, garantendo che ogni blocco che forniamo soddisfi i più alti standard di qualità e coerenza.',
      mainDescription3: 'Il nostro team esperto di esperti di cava e specialisti della pietra è dedicato a fornire la migliore esperienza possibile al cliente. Prestiamo grande attenzione a comprendere le vostre esigenze di pietra e forniamo soluzioni di approvvigionamento affidabili che supereranno le vostre aspettative. Dall\'estrazione alla consegna, manteniamo il controllo completo del processo di qualità.',
      ourValues: 'I Nostri Valori',
      ourMission: 'La Nostra Missione',
      ourVision: 'La Nostra Visione',
      quality: 'Qualità Premium',
      qualityDesc: 'Possediamo e gestiamo le migliori cave del mondo, garantendo standard eccezionali in ogni blocco di pietra.',
      expertise: 'Conoscenza Esperta',
      expertiseDesc: 'I nostri esperti di cava qualificati portano decenni di esperienza nell\'estrazione della pietra e nella valutazione della qualità.',
      service: 'Fornitura Affidabile',
      serviceDesc: 'Fornitura costante e affidabile di blocchi di pietra direttamente dalle nostre cave ai vostri progetti.',
      innovation: 'Innovazione',
      innovationDesc: 'Miglioramento continuo delle tecniche di estrazione e dei processi di controllo qualità.',
      yearsExperience: 'Anni di Esperienza',
      happyClients: 'Clienti Soddisfatti',
      projectsCompleted: 'Blocchi di Pietra Forniti',
      countriesServed: 'Paesi Serviti',
      missionText: 'Fornire i migliori blocchi di pietra naturale offrendo un servizio eccezionale e creando relazioni durature con i nostri clienti in tutto il mondo attraverso operazioni dirette di cava.',
      visionText: 'Essere il leader globale nella fornitura di blocchi di pietra premium, stabilendo lo standard per qualità, affidabilità e soddisfazione del cliente nell\'industria della pietra naturale.',
      whyChooseUs: 'Perché Scegliere Noi',
      globalReach: 'Portata Globale',
      globalReachDesc: 'Serviamo clienti in tutti i continenti con operazioni di cava affidabili e catene di approvvigionamento',
      sustainability: 'Estrazione Sostenibile',
      sustainabilityDesc: 'Impegnati in pratiche di estrazione responsabili e gestione ambientale',
      directSupply: 'Direttamente dalla Cava',
      directSupplyDesc: 'Eliminando intermediari fornendo blocchi di pietra direttamente dalle nostre cave',
      qualityAssurance: 'Garanzia di Qualità',
      qualityAssuranceDesc: 'Test e certificazioni rigorosi per tutti i blocchi di pietra dalle nostre cave'
    }
  };

  const t = translations[language] || translations.en;

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    const handleMouseMove = (e) => {
      const x = (e.clientX / window.innerWidth - 0.5) * 2;
      const y = (e.clientY / window.innerHeight - 0.5) * 2;
      setMousePosition({ x, y });
    };

    window.addEventListener('scroll', handleScroll);
    window.addEventListener('mousemove', handleMouseMove);

    // Animation observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('in-view');
          }
        });
      },
      { threshold: 0.1 }
    );

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach((el) => observer.observe(el));

    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('mousemove', handleMouseMove);
      observer.disconnect();
    };
  }, []);

  return (
    <div className="about-container">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="hero-background">
          <div 
            className="parallax-layer layer-1" 
            style={{ transform: `translateY(${scrollY * 0.3}px)` }}
          />
        </div>
        
        <div className="hero-content">
          <h1 className="hero-title">{t.heroTitle}</h1>
          <p className="hero-subtitle">{t.heroSubtitle}</p>
          
          {/* Animated Icon */}
          <div className="hero-icon">
            <div className="icon-circle">
              <div className="icon-inner">🏢</div>
              <div className="icon-ring ring-1"></div>
              <div className="icon-ring ring-2"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Company Introduction */}
      <section className="company-intro">
        <div className="intro-container">
          <div className="company-name animate-on-scroll">
            <h2>{t.companyName}</h2>
            <div className="name-underline"></div>
          </div>
          
          <div className="intro-content">
            <div className="intro-text animate-on-scroll">
              <p className="intro-paragraph">{t.mainDescription1}</p>
              <p className="intro-paragraph">{t.mainDescription2}</p>
              <p className="intro-paragraph">{t.mainDescription3}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats Counter Section */}
      <section className="stats-section">
        <div className="stats-container">
          <div className="stat-item animate-on-scroll">
            <div className="stat-icon">📅</div>
            <div className="stat-number">15+</div>
            <div className="stat-label">{t.yearsExperience}</div>
          </div>
          
          <div className="stat-item animate-on-scroll">
            <div className="stat-icon">😊</div>
            <div className="stat-number">500+</div>
            <div className="stat-label">{t.happyClients}</div>
          </div>
          
          <div className="stat-item animate-on-scroll">
            <div className="stat-icon">🏗️</div>
            <div className="stat-number">1000+</div>
            <div className="stat-label">{t.projectsCompleted}</div>
          </div>
          
          <div className="stat-item animate-on-scroll">
            <div className="stat-icon">🌍</div>
            <div className="stat-number">25+</div>
            <div className="stat-label">{t.countriesServed}</div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="values-section">
        <div className="values-container">
          <h2 className="section-title animate-on-scroll">{t.ourValues}</h2>
          
          <div className="values-grid">
            <div className="value-card animate-on-scroll">
              <div className="value-icon">
                <div className="icon-animation">💎</div>
              </div>
              <h3>{t.quality}</h3>
              <p>{t.qualityDesc}</p>
            </div>
            
            <div className="value-card animate-on-scroll">
              <div className="value-icon">
                <div className="icon-animation">🧠</div>
              </div>
              <h3>{t.expertise}</h3>
              <p>{t.expertiseDesc}</p>
            </div>
            
            <div className="value-card animate-on-scroll">
              <div className="value-icon">
                <div className="icon-animation">🚚</div>
              </div>
              <h3>{t.service}</h3>
              <p>{t.serviceDesc}</p>
            </div>
            
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="mission-vision">
        <div className="mv-container">
          <div className="mission-card animate-on-scroll">
            <div className="mv-icon">🎯</div>
            <h3>{t.ourMission}</h3>
            <p>{t.missionText}</p>
          </div>
          
          <div className="vision-card animate-on-scroll">
            <div className="mv-icon">🔭</div>
            <h3>{t.ourVision}</h3>
            <p>{t.visionText}</p>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="why-choose">
        <div className="why-container">
          <h2 className="section-title animate-on-scroll">{t.whyChooseUs}</h2>
          
          <div className="reasons-grid">
            <div className="reason-item animate-on-scroll">
              <div className="reason-icon">🌐</div>
              <h4>{t.globalReach}</h4>
              <p>{t.globalReachDesc}</p>
            </div>
            
            <div className="reason-item animate-on-scroll">
              <div className="reason-icon">🌱</div>
              <h4>{t.sustainability}</h4>
              <p>{t.sustainabilityDesc}</p>
            </div>
            
            <div className="reason-item animate-on-scroll">
              <div className="reason-icon">⛏️</div>
              <h4>{t.directSupply}</h4>
              <p>{t.directSupplyDesc}</p>
            </div>
            
            <div className="reason-item animate-on-scroll">
              <div className="reason-icon">✅</div>
              <h4>{t.qualityAssurance}</h4>
              <p>{t.qualityAssuranceDesc}</p>
            </div>
          </div>
        </div>
      </section>

      {/* Floating Background Elements */}
      <div className="background-shapes">
        <div 
          className="shape shape-1"
          style={{ transform: `translate(${mousePosition.x * 20}px, ${mousePosition.y * 20}px)` }}
        />
        <div 
          className="shape shape-2"
          style={{ transform: `translate(${mousePosition.x * -15}px, ${mousePosition.y * -15}px)` }}
        />
        <div 
          className="shape shape-3"
          style={{ transform: `translate(${mousePosition.x * 10}px, ${mousePosition.y * -10}px)` }}
        />
      </div>
    </div>
  );
};

export default About;